













































































































































































import { Toast, Dialog } from 'vant';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getUser, userPrize, messageSave } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Popup } from 'vant';

Vue.use(Popup);
@Component
export default class User extends Vue {
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  showPop: boolean = false;
  data: any = [];
  mess: any = [];
  name: string = '';
  phone: string = '';
  addr: string = '';
  pointOut = false;
  sign: number = 1;
  title: number = 1;
  btn: string = '提交';
  imgNumber: number = 0;
  img: any = [
    { url: require('../assets/prize1.jpg'), id: 1 },
    { url: require('../assets/prize1.jpg'), id: 2 },
    { url: require('../assets/prize2.jpg'), id: 3 },
    { url: require('../assets/prize3.jpg'), id: 4 },
    { url: require('../assets/prize4.jpg'), id: 5 },
    { url: require('../assets/prize1.jpg'), id: 6 },
    { url: require('../assets/prize6.jpg'), id: 7 },
    { url: require('../assets/prize1.jpg'), id: 8 },
    { url: require('../assets/prize8.jpg'), id: 9 },
  ];
  async mounted() {
    const res: any = await getUser();
    this.data = res.data;
    // const res1: any = await userPrize();
    // this.imgNumber = Number(res1.data.prize_config_id);
    // if (!res1.data.name && res1.data) {
    //   this.showPop = true;
    // }
    if (this.$route.query.title) {
      this.title = Number(this.$route.query.title);
    }
    // this.mess = res1.data;
    window.userInfoChange = () => {
      this.$router.go(0);
    };
  }
  toDetail(id: number) {
    this.$router.push({
      path: 'detail',
      query: {
        id: String(id),
      },
    });
  }
  handleClickUpload() {
    if (!window.udid) {
      this.tipDownloadApp();
      return;
    }
    if (window.gettoken() && window.gettoken() !== 'null') {
      this.$router.push({
        path: 'save',
      });
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
  }
  returnPage() {
    // if (window.history.length <= 1) {
    //   this.$router.push({
    //     path: 'home',
    //   });
    // } else {
    //   this.$router.go(-1);
    // }
    this.$router.push({
      path: 'home',
    });
  }
  tipDownloadApp() {
    Dialog.confirm({
      title: '友情提示',
      message: '请在上游新闻App进行报名',
      confirmButtonText: '还没装？一步安装',
      cancelButtonText: '我已安装过',
      closeOnClickOverlay: true,
    })
      .then(() => {
        window.location.href = this.downLoadUrl;
      })
      .catch(() => {
        if (isWeiXin() === true) {
          this.pointOut = true;
        } else {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        }
      });
  }

  changTitle(title: number) {
    this.title = title;
  }
  async submit(type: number) {
    const noData = !this.name || !this.phone || !this.addr;
    const data = {
      name: this.name,
      phone: this.phone,
      address: this.addr,
    };
    if (noData) {
      Toast('请填写信息');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('请正确输入手机号');
      return false;
    } else {
      this.sign = type;
      this.showPop = true;
    }
    if (this.sign !== 1) {
      const res: any = await messageSave(data);
      if (res.code === 200) {
        Toast('提交成功');
      } else {
        Toast('提交失败');
      }
    }
  }
}
